import { RootState } from '@shared/model';

export const selectTemplates = (state: RootState) => state.invoiceTemplate.templates;
